import { MutationTree } from "vuex";
import { IAppState } from "./state";
import {
    SET_LANG,
    UPDATE_TIME,
    LOAD,
    REFRESH_SASTOKEN,
} from "./mutations-types";

export const mutations: MutationTree<IAppState> = {

    [SET_LANG](state, payload: string): void {
        state.lang = payload;
    },

    [UPDATE_TIME](state) {
        state.now = new Date();
    },

    [LOAD](state) {
        state.loaded = true;
    },

    [REFRESH_SASTOKEN](state, payload: any): void {
        state.sasToken = payload.sasToken;
    },

};
